var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./home.css";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import Modal from "react-modal";
import goIcon from "../../assets/icons/go-icon.svg";
import { Link } from "react-router-dom";
import { raffleCategories } from "../../store/games.store";
import { HomeNewRaffleWidget, HomeRaffleWidget } from "./raffle.widget";
import { modalServiceSubject } from "../../services/modal.service";
import { categoryEmojiMapping, env } from "../../constants/global.constants";
import { ResetPassword } from "../../shared/auth/resetpassword";
import { isMobile } from "../../App";
import { VerifyEmail } from "../../shared/auth/verify.email";
import { getRaffleCategories } from "../../services/game.service";
import { useForceUpdate } from "../../services/misc.functions";
import { api } from "../../services/http.service";
import { useNavigate } from "react-router";
import DOMPurify from "dompurify";
import { useForm } from "react-hook-form";
import "swiper/css/navigation";
import { auth } from "../../store/auth.store";
import InputMask from "react-input-mask";
import campagin1 from "../../assets/images/esanspopup1.png";
import paths from "../../paths";
import { HomeGamesVertical } from "./games.vertical";
import { HomeGamesSwiper } from "./multiGameSwiper";
export function Home() {
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    var _a = useState(null), homeStats = _a[0], setHomeStats = _a[1];
    var _b = useState(false), showStoryModal = _b[0], setShowStoryModal = _b[1];
    function closeModal() {
        setShowStoryModal(false);
    }
    useEffect(function () {
        getRaffleCategories().then(function (res) {
            api
                .start("post", env.accounting_api + "/misc/api/list-flatpages/", { slug: "anasayfa-stats" }, false)
                .then(function (res) {
                setHomeStats(res.data.content);
            });
        });
    }, []);
    var sanitizedData = function () { return ({
        __html: DOMPurify.sanitize(homeStats),
    }); };
    // story modal kaç sn ekranda kalacak buradan belirleniyor
    useEffect(function () {
        setTimeout(function () {
            setShowStoryModal(false);
        }, 10000);
    }, [showStoryModal]);
    useEffect(function () {
        document.body.setAttribute("style", "background: linear-gradient(to bottom, #40BC62 0px, #40BC62 400px, #E3EEED 400px, #E3EEED 100%) !important; min-height: 100vh; margin: 0;");
        return function () {
            // başka sayfaya geçince geri düzelt
            document.body.setAttribute("style", "background: #E3EEED !important; min-height: 100vh; margin: 0;");
        };
    }, []);
    var _c = useForm(), register = _c.register, handleSubmit = _c.handleSubmit, reset = _c.reset, errors = _c.formState.errors;
    var onSubmit = function (payload) {
        if (auth.member && auth.member.id) {
            api
                .start("post", env.accounting_api + "/somos/api/check-coupon/", payload, true)
                .then(function (res) {
                if (res && res.status && res.count > 0) {
                    modalServiceSubject.next({
                        case: res.data[0].status === "Oynandı"
                            ? "info"
                            : res.data[0].status === "Kazandı"
                                ? "success"
                                : "danger",
                        title: res.data[0].status,
                        content: "<p class=\"text-center\">Ad\u0131n\u0131za kay\u0131tl\u0131 ".concat(payload.approve_code, " numaral\u0131 biletiniz, ").concat(res.data[0].draw_is_result
                            ? res.data[0].status + " olarak değerlendirilmiştir."
                            : "henüz sonuçlanmamıştır.", "</p>"),
                        confirm: {
                            cancel: {
                                label: "Kapat",
                                class: "btn btn-info w-100",
                            },
                        },
                    });
                }
                else {
                    modalServiceSubject.next({
                        case: "info",
                        title: "Bilet bulunamadı",
                        content: "<p class=\"text-center\">Ad\u0131n\u0131za kay\u0131tl\u0131 b\u00F6yle bir bilet numaras\u0131 bulunamad\u0131. L\u00FCtfen bilet numaran\u0131z\u0131 kontrol edip tekrar deneyin.</p>",
                        confirm: {
                            cancel: {
                                label: "Kapat",
                                class: "btn btn-info w-100",
                            },
                        },
                    });
                }
                // console.log(res)
            });
        }
        else {
            if (isMobile) {
                navigate(paths.landing.url);
            }
            else {
                modalServiceSubject.next({
                    class: "success",
                    title: "Üye Girişi",
                    content: "<p>Bilet sorgulama i\u00E7in \u00F6nce oturum a\u00E7man\u0131z gerekli. \u00DCye de\u011Filseniz hemen \u00FCye olabilir yada giri\u015F yaparak al\u0131\u015Fveri\u015Finizi tamamlaya bilirsiniz.</p>",
                    confirm: {
                        sure: {
                            label: "Giriş Yap",
                            class: "btn btn-success",
                            action: function () {
                                navigate(paths.login.url);
                            },
                        },
                        cancel: {
                            label: "Üye Ol",
                            class: "btn btn-info",
                            action: function () {
                                navigate(paths.register.url);
                            },
                        },
                    },
                });
            }
        }
    };
    return (_jsxs(_Fragment, { children: [!isMobile && (
            //story modu
            // <div className="row justify-items-center">
            //   <div
            //     className="home-counter col mb-3 d-flex justify-content-center align-items-center"
            //     id="id_home_stat_container"
            //   >
            //     <a
            //       onClick={() => {
            //         setShowStoryModal(true);
            //       }}
            //     >
            //       <img
            //         className={"icon-box icon-box-static"}
            //         src={prizceIcon}
            //         alt=""
            //       />
            //       <img className={"icon-box"} src={prizceIconGif} alt="" />
            //     </a>
            //     <h4 className="mt-2 mx-2">Test</h4>
            //   </div>
            //   <div
            //     className="home-counter col mb-3 d-flex justify-content-center align-items-center"
            //     id="id_home_stat_container"
            //   >
            //     <a
            //       onClick={() => {
            //         setShowStoryModal(true);
            //       }}
            //     >
            //       <img
            //         className={"icon-box icon-box-static"}
            //         src={prizceIcon}
            //         alt=""
            //       />
            //       <img className={"icon-box"} src={prizceIconGif} alt="" />
            //     </a>
            //     <h4 className="mt-2 mx-2">Test</h4>
            //   </div>
            //   <div
            //     className="home-counter col mb-3 d-flex justify-content-center align-items-center"
            //     id="id_home_stat_container"
            //   >
            //     <a
            //       onClick={() => {
            //         setShowStoryModal(true);
            //       }}
            //     >
            //       <img
            //         className={"icon-box icon-box-static"}
            //         src={giftIcon}
            //         alt=""
            //       />
            //       <img className={"icon-box"} src={giftIconGif} alt="" />
            //     </a>
            //     <h4 className="mt-2 mx-2">Test</h4>
            //   </div>
            //   <div
            //     className="home-counter col mb-3 d-flex justify-content-center align-items-center"
            //     id="id_home_stat_container"
            //   >
            //     <a
            //       onClick={() => {
            //         setShowStoryModal(true);
            //       }}
            //     >
            //       <img
            //         className={"icon-box icon-box-static"}
            //         src={winIcon}
            //         alt=""
            //       />
            //       <img className={"icon-box"} src={winIconGif} alt="" />
            //     </a>
            //     <h4 className="mt-2 mx-2">Test</h4>
            //   </div>
            //   <div
            //     className="home-counter col mb-3 d-flex justify-content-center align-items-center"
            //     id="id_home_stat_container"
            //   >
            //     <a
            //       onClick={() => {
            //         setShowStoryModal(true);
            //       }}
            //     >
            //       <img
            //         className={"icon-box icon-box-static"}
            //         src={birdIcon}
            //         alt=""
            //       />
            //       <img className={"icon-box"} src={birdIconGif} alt="" />
            //     </a>
            //     <h4 className="mt-2 mx-2">Test</h4>
            //   </div>
            // </div>
            // <div
            //   className="row d-flex justify-items-center mb-3 pe-2 campaign-card-container"
            //   style={{ paddingInline: "4px" }}
            // >
            //   <div className="col-4 d-flex align-items-stretch">
            //     <div className="campagin-card">
            //       <a
            //         className="link text-decoration-none text-black"
            //         href="/dijital-oyunlar"
            //       >
            //         <div className="row mt-2 mb-3">
            //           <div className="col-6 d-flex align-items-center justify-content-center px-4">
            //             <img
            //               className="img-fluid"
            //               src="/f96ddae361d15b182fb07318425fa8f3.png"
            //               alt=""
            //             />
            //           </div>{" "}
            //           <div className="col-6 d-flex align-items-center justify-content-center px-3">
            //             {/* <img
            //               className="img-fluid"
            //               src="/e7caf260421cae3327e2e64f51e8b3eb.png"
            //               alt=""
            //             /> */}
            //           </div>
            //         </div>
            //         <div className="row px-3 my-1">
            //           <h6 className="" style={{ whiteSpace: "normal" }}>
            //             Türkiye'nin yasal şans oyunları sanal bayisi
            //           </h6>
            //         </div>
            //       </a>
            //     </div>
            //   </div>
            //   <div className="col-4 d-flex align-items-stretch">
            //     <div className=" campagin-card">
            //       <a
            //         className="link text-decoration-none text-black"
            //         href="/dijital-oyunlar"
            //       >
            //         <div className="row">
            //           <div className="col-3 d-flex align-items-center justify-content-center">
            //             <img
            //               className={"icon-box icon-box-static"}
            //               src={hediyeIcon}
            //               alt=""
            //             />
            //             <img className={"icon-box"} src={hediyeIcon} alt="" />
            //           </div>
            //           <div className="col-6">
            //             <div className="row">
            //               <h5 className="mt-2" style={{ whiteSpace: "normal" }}>
            //                 Dijital Oyunlar
            //               </h5>
            //             </div>
            //           </div>
            //           <div className="col-3 py-2">
            //             {/* <span
            //               className={"py-1 px-2 rounded text-white bg-danger me-2"}
            //               style={{ fontSize: "9px" }}
            //             >
            //               YENİ
            //             </span> */}
            //           </div>
            //         </div>
            //         <div className="row px-3 my-1">
            //           <h6 className="" style={{ whiteSpace: "normal" }}>
            //             Birbirinden eğlenceli ve bol kazançlı oyunlar e-Şans'ta!
            //           </h6>
            //         </div>
            //       </a>
            //     </div>
            //   </div>
            //   <div className="col-4 d-flex align-items-stretch">
            //     <div className="campagin-card">
            //       <a
            //         className="link text-decoration-none text-black"
            //         href="/kampanyalar"
            //       >
            //         <div className="row">
            //           <div className="col-3 d-flex align-items-center justify-content-center">
            //             <img
            //               className={"icon-box icon-box-static"}
            //               src={kazikazanIcon}
            //               alt=""
            //             />
            //             <img className={"icon-box"} src={kazikazanIcon} alt="" />
            //           </div>
            //           <div className="col-6">
            //             <div className="row">
            //               <h5 className="mt-2" style={{ whiteSpace: "normal" }}>
            //                 25.000 TL Kazanma Fırsatı
            //               </h5>
            //             </div>
            //           </div>
            //           <div className="col-3 py-2">
            //             <span
            //               className={"py-1 px-2 rounded text-white bg-danger me-2"}
            //               style={{ fontSize: "9px" }}
            //             >
            //               YENİ
            //             </span>
            //           </div>
            //         </div>
            //         <div className="row px-3 my-1">
            //           <h6 className="" style={{ whiteSpace: "normal" }}>
            //             Her gün 25.000 TL Kazanma Fırsatı Kazı Kazan kampanyasında!
            //           </h6>
            //         </div>
            //       </a>
            //     </div>
            //   </div>
            // </div>
            // <div className="row">
            //   <div
            //     id="id_home_stat_container"
            //     className="home-counter col-12 mb-3"
            //     dangerouslySetInnerHTML={sanitizedData()}
            //   ></div>
            // </div>
            _jsx(_Fragment, {})), !isMobile && (_jsxs("div", __assign({ style: { marginTop: "-14px" } }, { children: [_jsx("div", __assign({ className: "row mb-3" }, { children: _jsx(HomeGamesSwiper, { gamesGroup: 0 }) })), _jsx("div", __assign({ className: "row mb-3" }, { children: _jsx(HomeGamesSwiper, { gamesGroup: 1 }) })), _jsx("div", __assign({ className: "row mb-3" }, { children: _jsx(HomeGamesSwiper, { gamesGroup: 2 }) }))] }))), isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row" }, { children: _jsxs("div", __assign({ className: "row drawers-slider-container-top" }, { children: [_jsx("h2", __assign({ className: "home-heading d-none d-xl-block d-lg-block" }, { children: "\u00C7ekili\u015Fler" })), _jsx("hr", { className: "d-none d-xl-block d-lg-block" }), !isMobile && (_jsxs("div", __assign({ className: "col-5 ", style: { filter: "drop-shadow(0 0 6px #cfe6e7)" } }, { children: [_jsx("div", __assign({ className: "widget blue mt-3" }, { children: _jsxs("div", __assign({ className: "body" }, { children: [_jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx("h2", { children: "Bilet Sorgula" }), _jsx("p", { children: "Bilet numaras\u0131n\u0131 ile durumunu sorgulayabiirsiniz." })] })), _jsxs("form", __assign({ className: "w-100", onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", __assign({ className: "my-2", style: { display: "flex" } }, { children: [_jsx(InputMask, __assign({ mask: "999999", className: "form-control py-2" }, register("approve_code", { required: true }), { placeholder: "Bilet Numaras\u0131" })), _jsx("button", __assign({ className: "btn btn-light mx-1" }, { children: _jsx("img", { src: goIcon }) }))] })), _jsx("div", {})] }))] })) })), _jsx("div", __assign({ className: "widget mt-3" }, { children: _jsx("div", __assign({ className: "body p-1" }, { children: _jsx(HomeNewRaffleWidget, {}) })) }))] }))), _jsxs("div", __assign({ className: "col-12 col-lg-7" }, { children: [isMobile && (_jsxs("div", __assign({ className: "mobile-menu-icon d-flex mt-0" }, { children: [_jsxs(Link, __assign({ to: paths.deposit.url, className: "col" }, { children: [_jsx("img", { src: "/assets/images/home_icon_deposit.png", alt: "" }), "Para Yat\u0131r"] })), _jsxs(Link, __assign({ to: paths.products.url, className: "col" }, { children: [_jsx("img", { src: "/assets/images/home_icon_products.png", alt: "" }), "\u00D6d\u00FCller"] })), _jsxs(Link, __assign({ to: paths.campaign.url, className: "col" }, { children: [_jsx("img", { src: "/assets/images/home_icon_campaign.png", alt: "" }), "Kampanyalar"] })), _jsxs(Link, __assign({ to: paths.liveStream.url, className: "col" }, { children: [_jsx("img", { src: "/assets/images/home_icon_live_stream.png", alt: "" }), "Canl\u0131 \u0130zle"] }))] }))), isMobile && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "slider-tabs mt-2", style: { "--tab-count": "3" } }, { children: [_jsx("input", { type: "radio", "data-rel": "tab1", id: "id_tab-1", name: "tabs" }), _jsx("label", __assign({ className: "tab mobile-white", htmlFor: "id_tab-1" }, { children: "Dijital Oyunlar" })), _jsx("input", { type: "radio", disabled: true, "data-rel": "tab2", id: "id_tab-2", name: "tabs" }), _jsx("label", { className: "tab", htmlFor: "id_tab-2" }), _jsx("input", { type: "radio", disabled: true, "data-rel": "tab3", id: "id_tab-3", name: "tabs" }), _jsx("label", __assign({ className: "tab", htmlFor: "id_tab-3", onClick: function () { return navigate(paths.games.url); }, style: { textDecoration: "underline" } }, { children: "T\u00FCm\u00FCn\u00FC G\u00F6r" })), _jsx("span", { className: "glider" })] })), _jsx(HomeGamesVertical, {})] })), _jsx("div", __assign({ className: "pointer " }, { children: _jsx(HomeRaffleWidget, { withCategories: false }) }))] }))] })) })), _jsx("div", __assign({ className: "row" }, { children: raffleCategories.length > 0 && !isMobile && (_jsx(HomeCategoryWidget, {})) }))] })), !isMobile && (_jsx("div", __assign({ className: "row" }, { children: _jsx(HomeCategoryWidget, {}) }))), _jsx(ResetPassword, {}), _jsx(VerifyEmail, {}), _jsx(Modal, __assign({ isOpen: showStoryModal, 
                // className={"default product-detail-modal"}
                className: "default", onRequestClose: closeModal, contentLabel: "", style: {
                    content: {
                        width: "40%",
                    },
                } }, { children: _jsx("img", { className: "img-fluid", src: campagin1, alt: "" }) }))] }));
}
export function HomeCategoryWidget() {
    var _a = useState("populer"), selectedCategory = _a[0], setSelectedCategory = _a[1];
    var navigate = useNavigate();
    // const {boxShadow, onScrollHandler} = useScrollWithShadow();
    // const navigationCatPrevRef = useRef(null);
    // const navigationCatNextRef = useRef(null);
    var width = window.innerWidth;
    var forceUpdate = useForceUpdate();
    // console.log(width);
    var resizeWindow = function () {
        width = window.innerWidth;
        forceUpdate();
    };
    useEffect(function () {
        window.addEventListener("resize", resizeWindow);
        return function () {
            window.removeEventListener("resize", resizeWindow);
        };
    }, []);
    return (_jsx("div", __assign({ className: "drawers-slider-container-bottom" }, { children: _jsxs("div", __assign({ className: "home-raffle-slider-with-category mb-4" }, { children: [_jsxs("div", __assign({ className: "categories mt-3 categories-slider-container" }, { children: [isMobile && (_jsxs(Swiper, __assign({ spaceBetween: 0, slidesPerView: width > 1400 ? 7 : width > 1100 ? 7 : 3, navigation: true, modules: [Navigation] }, { children: [_jsx(SwiperSlide, { children: _jsx("div", { children: _jsx("a", __assign({ className: "pointer category-slider-item", onClick: function () {
                                                // navigate(paths.raffleTickets+'?category='+category.id)
                                                setSelectedCategory("populer");
                                                navigate(paths.raffleTickets.url);
                                            } }, { children: "T\u00FCm\u00FC" })) }, "all-category") }, "all-category-slide"), raffleCategories.map(function (category, key) {
                                    return (_jsx(SwiperSlide, { children: _jsx("div", __assign({ className: selectedCategory === category
                                                ? "category-slider-item-active"
                                                : "" }, { children: _jsxs("a", __assign({ className: "pointer category-slider-item", onClick: function () {
                                                    // navigate(paths.raffleTickets+'?category='+category.id)
                                                    if (selectedCategory === category) {
                                                        setSelectedCategory("populer");
                                                    }
                                                    else {
                                                        setSelectedCategory(category);
                                                    }
                                                } }, { children: [categoryEmojiMapping[category.id], " ", category.name] })) }), "".concat(key, "-category")) }, "".concat(key, "-category-slide")));
                                })] }))), !isMobile && (_jsx(_Fragment, { children: _jsxs(Swiper, __assign({ className: "categories-row", spaceBetween: 0, slidesPerView: width > 1400 ? 7 : width > 1100 ? 5 : 3, navigation: true, modules: [Navigation] }, { children: [_jsx(SwiperSlide, __assign({ className: "drawer-category-selector", onClick: function () {
                                            // navigate(paths.raffleTickets+'?category='+category.id)
                                            setSelectedCategory("populer");
                                            navigate(paths.raffleTickets.url);
                                        } }, { children: "T\u00FCm\u00FC" })), raffleCategories.map(function (category, key) {
                                        return (_jsx(SwiperSlide, __assign({ className: "drawer-category-selector text-break ".concat(selectedCategory === category ? 'drawer-category-selector-active' : ''), onClick: function () {
                                                // navigate(paths.raffleTickets+'?category='+category.id)
                                                if (selectedCategory === category) {
                                                    setSelectedCategory("populer");
                                                }
                                                else {
                                                    setSelectedCategory(category);
                                                }
                                            } }, { children: category.name }), "".concat(key, "-category-slide")));
                                    })] })) }))] })), _jsx("div", __assign({ className: "widget raffles" }, { children: _jsx(HomeRaffleWidget, { selectedCategory: selectedCategory, withCategories: true }) }))] })) })));
}
